import React, { useState, useRef, useEffect } from "react";
import "./style.css";
import CompanyDetailGln from "./CompanyDetailGln";
import ProductDetailGln from "./ProductDetailGln";
import NewWarning from "../newWarning";
import LinkSetGln from "./LinkSetGln";

const GlnResults = ({ data }: { data: any }) => {
  const [activeTab, setActiveTab] = useState("tab1");
  
  useEffect(() => {
    // Define a primeira tab disponível como ativa (prioridade: tab2 > tab1 > tab3)
    if (!!data.productData && data.productData.length > 0) {
      setActiveTab("tab1");
    } else if (data.companyData && Object.keys(data.companyData).length > 0) {
      setActiveTab("tab2");
    } else if (!!data.linkset) {
      setActiveTab("tab3");
    }
  }, [data]);

  const handleTab1 = () => {
    // update the state to tab1
    setActiveTab("tab1");
  };

  const handleTab2 = () => {
    // update the state to tab2
    setActiveTab("tab2");
  };

  const handleTab3 = () => {
    // update the state to tab2
    setActiveTab("tab3");
  };
  const windowSize = useRef([window.innerWidth, window.innerHeight]);


  return (

    <div className="Tabs">
      <div className=' ' style={{ width: '100%' }}>


        {(data.retornoMsg.showMSG) && (
          <NewWarning
            type={data.retornoMsg.vbg_status}
            showpick={data.retornoMsg.vbg_show_pic}
            title={data.retornoMsg.vbg_title}
            text={data.retornoMsg.vbg_error_message}

          ></NewWarning>
        )}

      </div>
      <>
        
      {data.companyData && Object.keys(data.companyData).length > 0 && (

          <>
            {data.retornoMsg.show_content && (
              <div>
                <ul className="nav">
                  {
                    <>
                      {
                        (!!data.productData && data.productData.length > 0) ?
                          <>
                            <li className={activeTab === "tab1" ? "active" : ""} onClick={handleTab1}>{windowSize.current[0] > 600 ? 'Informações do GLN' : 'GLN'}</li>
                          </> :
                          <></>
                      }
                      <li className={activeTab === "tab2" ? "active" : ""} onClick={handleTab2}>{windowSize.current[0] > 600 ? 'Informações da Empresa' : 'Empresa'}</li>
                      {
                        (!!data.linkset) ?
                          <>
                            <li className={activeTab === "tab3" ? "active" : ""} onClick={handleTab3}>{windowSize.current[0] > 600 ? 'Links de registro' : 'Links'}</li>
                          </> :
                          <></>
                      }
                    </>
                  }

                </ul>

                <div className="outlet">

                  {
                    <>
                      {
                        activeTab === "tab1" ?
                          <><ProductDetailGln data={data} /> </>
                          :
                          activeTab === "tab2" ?
                            <><CompanyDetailGln data={data} /> </>
                            :
                            <><LinkSetGln data={data.linkset} /> </>
                      }
                    </>
                  }



                </div>
              </div>
            )}
          </>
        )}


      </>

    </div>
  );
};
export default GlnResults;
